import React from "react";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators";
import OddsMobileMenuItem from "./Odds.mobile.MenuItem";
import PropTypes from "prop-types";

const OddsMobile = ({ trackingInfo }) => {
  const dispatch = useDispatch();
  const itemTermKey = "odds-menu-item";

  const handleMenuItemClick = () => {
    dispatch(MenuActionCreators.hideHamburgerMenu());
    dispatch(MenuActionCreators.showOddsMenu());
  };

  return (
    <OddsMobileMenuItem
      itemTermKey={itemTermKey}
      handleClick={handleMenuItemClick}
      trackingInfo={trackingInfo}
    />
  );
};

OddsMobile.propTypes = {
  trackingInfo: PropTypes.object
};

export { default as Odds } from "./Odds";
export default OddsMobile;
